"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTOSAVE_TIMEOUT_INTERVAL = void 0;
var react_1 = require("react");
var objectUtils_1 = require("./objectUtils");
exports.AUTOSAVE_TIMEOUT_INTERVAL = 1000; // miliseconds
function useAutosaveForm(onSaveValues, defaultValues, currentValues) {
    var saveTimer = (0, react_1.useRef)();
    var _a = (0, react_1.useState)(null), changeId = _a[0], setChangeId = _a[1];
    // Must keep constant copy of defaultValues so this should not update
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var initialValues = (0, react_1.useMemo)(function () { return (__assign({}, defaultValues)); }, []);
    var _b = (0, react_1.useState)(__assign({}, initialValues)), values = _b[0], setValues = _b[1];
    var updateValues = function (updatedValues) {
        setValues(function (prevValues) { return (__assign(__assign({}, prevValues), updatedValues)); });
        setChangeId(Date.now());
    };
    var handleChange = function (name) { return function (event) {
        var _a;
        updateValues((_a = {}, _a[name] = event.target.value, _a));
    }; };
    var handleValueChange = function (name) { return function (value) {
        var _a;
        updateValues((_a = {}, _a[name] = value, _a));
    }; };
    var handleSliderChange = function (name) { return function (_event, value) {
        var _a;
        updateValues((_a = {}, _a[name] = value, _a));
    }; };
    var handleMultiSelectChange = function (name, answer) { return function (_event, checked) {
        var _a;
        var responses = (values[name] || []).filter(function (d) { return d !== answer; });
        var value = checked ? __spreadArray(__spreadArray([], responses, true), [answer], false) : responses;
        updateValues((_a = {}, _a[name] = value, _a));
    }; };
    var handleNumberChange = function (name) { return function (event) {
        var _a;
        updateValues((_a = {}, _a[name] = Number(event.target.value), _a));
    }; };
    var saveResponses = (0, react_1.useCallback)(function (updatedValues, callback, background) {
        if (changeId) {
            var internalCallback = function () {
                setChangeId(function (prevId) { return (prevId === changeId ? null : prevId); });
                if (callback) {
                    callback();
                }
            };
            onSaveValues(updatedValues, internalCallback, background);
        }
    }, [changeId, onSaveValues]);
    var ensureSaved = function (callback) {
        if (changeId) {
            if (saveTimer.current) {
                clearTimeout(saveTimer.current);
            }
            saveResponses(values, callback);
        }
        else if (callback) {
            callback();
        }
    };
    (0, react_1.useEffect)(function () {
        if (changeId) {
            if (saveTimer.current) {
                clearTimeout(saveTimer.current);
            }
            saveTimer.current = setTimeout(function () {
                saveResponses(values, null, true);
            }, exports.AUTOSAVE_TIMEOUT_INTERVAL);
        }
    }, [changeId, saveResponses, values]);
    (0, react_1.useEffect)(function () {
        if (!changeId) {
            if (currentValues) {
                var valuesToSet_1 = Object.keys(currentValues)
                    .reduce(function (obj, key) {
                    var _a;
                    return ((0, objectUtils_1.hasValue)(currentValues[key]) ? __assign(__assign({}, obj), (_a = {}, _a[key] = currentValues[key], _a)) : obj);
                }, {});
                setValues(function (prev) { return (__assign(__assign({}, prev), valuesToSet_1)); });
            }
            else {
                setValues(__assign({}, initialValues));
            }
        }
    }, [currentValues, changeId, initialValues]);
    return {
        values: values,
        handleChange: handleChange,
        handleValueChange: handleValueChange,
        handleNumberChange: handleNumberChange,
        handleMultiSelectChange: handleMultiSelectChange,
        handleSliderChange: handleSliderChange,
        ensureSaved: ensureSaved,
    };
}
exports.default = useAutosaveForm;
